import * as React from "react";
import * as BS from "react-bootstrap";
import * as BT from "react-bootstrap-table";
import { Icon } from "../generic";

interface OptionalProps {
    changeLength?: boolean;
    changePage?: boolean;
    initialPageSize?: number;
    initialSearchText?: string;
    lengthMenu?: number[];
    lengthMenuFormat?: (size: number) => string;
    search?: boolean;
    searchPlaceholder?: string;
    showInfo?: boolean;
}

type OwnProps = OptionalProps & {
    dataLength: number;
    filteredLength: number;
    page: number;
    pageSize: number;
    table: BT.BootstrapTable;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    onSearch: (search: string) => void;
};

interface OwnState {
    search: string;
}

export class BootstrapTableActions extends React.Component<OwnProps, OwnState> {

    public static defaultProps: OptionalProps = {
        changeLength: true,
        changePage: true,
        initialPageSize: 5,
        lengthMenu: [5, 10, 25, 100, -1],
        lengthMenuFormat: (size: number) => size === -1 ? "Show all" : `Show ${size} per page`,
        search: true,
        showInfo: true,
    };

    private _searchTimeout: NodeJS.Timer;

    public constructor(props: OwnProps) {
        super(props);
        this.state = {
            search: props.initialSearchText || "",
        };
    }

    public render() {

        const pages = this.getTotalPages();

        // create page info text
        let pageInfo: JSX.Element | null = null;
        if (this.props.showInfo) {
            const rows = this.props.filteredLength;
            const sp = Math.min(((this.props.page - 1) * (this.props.pageSize || rows)) + 1, rows);
            const ep = this.props.pageSize === -1
                ? this.props.filteredLength
                : Math.min(this.props.page * (this.props.pageSize || rows), rows);
            const filtered = rows !== this.props.dataLength ? ` (filtered from ${this.props.dataLength} total entries)` : "";
            pageInfo = <div className="page-info">
                    <strong>{sp}&ndash;{ep}</strong>
                    {" of "}
                    <strong>{rows}</strong>{filtered}
                </div>;
        }

        const search = this.props.search
            ? <div className="input-group results-search">
                <input
                    className="form-control"
                    type="text"
                    placeholder={this.props.searchPlaceholder || "Search..."}
                    onChange={(e) => this.handleSearch(e.target.value)}
                    value={this.state.search || ""}
                />
                <div className="input-group-btn">
                    <BS.Button onClick={() => this.handleSearch("")} >
                        <i className="fa fa-times"></i>
                    </BS.Button>
                </div>
            </div>
            : null;

        const pageChange = this.props.changePage || this.props.changeLength
            ? <BS.ButtonGroup className="page-tools">
                <BS.Button className={this.props.page <= 1 ? "disabled" : ""} onClick={() => this.handlePageChange("prev")}>
                    <Icon icon="chevron-left" />
                </BS.Button>
                <BS.Button className={this.props.page >= pages || pages === 0 ? "disabled" : ""} onClick={() => this.handlePageChange("next")}>
                    <Icon icon="chevron-right" />
                </BS.Button>
            </BS.ButtonGroup>
            : null;

        // create page size dropdown
        let lengthMenu = null;
        if (this.props.changeLength && this.props.lengthMenu && this.props.lengthMenu.length) {
            const lengthFormatter = this.props.lengthMenuFormat || ((size: number) => size.toString());
            lengthMenu = <div className="page-length">
                <BS.DropdownButton id="" pullRight title={lengthFormatter(this.props.pageSize || this.props.lengthMenu[0])}>
                    {this.props.lengthMenu.map((size, i) => {
                        return <BS.MenuItem key={i} onClick={() => this.handlePageSizeChange(size)}>
                            {lengthFormatter(size)}
                        </BS.MenuItem>;
                    })}
                </BS.DropdownButton>
            </div>;
        }

        return <div className="paging-tools">
            <div id="pagination">
                {pageInfo}
                {search}
                {pageChange}
                {lengthMenu}
            </div>
        </div>;
    }

    private getTotalPages() {
        return Math.ceil(this.props.filteredLength / (this.props.pageSize < 1 ? this.props.filteredLength : this.props.pageSize));
    }

    private handleSearch(search: string) {
        this.setState({ ...this.state, search });

        if (this._searchTimeout)
            clearTimeout(this._searchTimeout);

        this._searchTimeout = setTimeout(async () => {
            this.props.onSearch(this.state.search);
        }, 275);
    }

    private handlePageChange(dir: "prev" | "next") {
        const page = this.props.page;
        if (dir === "prev" && page > 1) {
            this.props.onPageChange(page - 1);
        }
        else if (dir === "next" && page < this.getTotalPages()) {
            this.props.onPageChange(page + 1);
        }
    }

    private handlePageSizeChange(size: number) {
        this.props.onPageSizeChange(size);
    }
}



// WEBPACK FOOTER //
// ./src/components/table/BootstrapTableActions.tsx